<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label">
    <label class="mb-0">
      <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label -->
      {{field.label}}<span class="required-asterisk" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
        <input [mask]="getMask()"
          class="field_submit"
          type="text"
          maxlength="200"
          [formControlName]="fieldKey"
          (input)="shouldValidateNumeric() ? onNumberInput($event) : null"
          (keypress)="shouldValidateNumeric() ? avoidAlphaCharacters($event) : null"
          (blur)="shouldFormatPrice() ? formatInputValue(fieldKey) : null" />
  </div>
</div>

<div *ngIf="field.format == 'email_with_confirmation'" class="confirmation field-wrapper" [formGroup]="formGroup">

  <div class="field-label">
    <label class="mb-0">
      <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label -->
      Confirm {{field.label}}<span class="required-asterisk" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="field-input">
    <input class="field_submit" 
            value="" 
            type="text" 
            maxlength="200"  
            [formControlName]="fieldKey + '_confirmation'"  />
  </div>

</div>